var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIota(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 342.171,
    height: 92.972,
    viewBox: "0 0 342.171 92.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1158",
    "data-name": "Rectangle 1158",
    width: 342.171,
    height: 92.972,
    rx: 11.867,
    fill: "#fff",
    stroke: "rgba(112,112,112,0.3)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24976",
    "data-name": "Group 24976",
    transform: "translate(86.82 18.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24974",
    "data-name": "Group 24974",
    transform: "translate(67.801 13.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52471",
    "data-name": "Path 52471",
    d: "M427.017,111.392H428.8v28.886h-1.782Z",
    transform: "translate(-427.017 -110.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52472",
    "data-name": "Path 52472",
    d: "M478.244,125.391a18.5,18.5,0,0,1-.93,5.927,14.214,14.214,0,0,1-2.691,4.814,12.49,12.49,0,0,1-4.309,3.216,14.9,14.9,0,0,1-11.591,0,12.45,12.45,0,0,1-4.329-3.216,14.2,14.2,0,0,1-2.69-4.814,19.334,19.334,0,0,1,0-11.854,14.221,14.221,0,0,1,2.69-4.815,12.455,12.455,0,0,1,4.329-3.216,14.9,14.9,0,0,1,11.591,0,12.516,12.516,0,0,1,4.309,3.216,14.221,14.221,0,0,1,2.691,4.815,18.505,18.505,0,0,1,.931,5.927Zm-25.69,0a16.769,16.769,0,0,0,.809,5.259,12.911,12.911,0,0,0,2.347,4.309,11.831,11.831,0,0,0,13.856,2.934,11.422,11.422,0,0,0,3.743-2.934,12.932,12.932,0,0,0,2.347-4.309,17.5,17.5,0,0,0,0-10.519,12.952,12.952,0,0,0-2.347-4.309,11.426,11.426,0,0,0-3.743-2.933,11.829,11.829,0,0,0-13.856,2.933,12.93,12.93,0,0,0-2.347,4.309,16.776,16.776,0,0,0-.809,5.261Z",
    transform: "translate(-436.325 -110.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52473",
    "data-name": "Path 52473",
    d: "M508.26,112.929v-1.537h22.13v1.537h-10.2v27.349h-1.782V112.929Z",
    transform: "translate(-458.848 -110.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52474",
    "data-name": "Path 52474",
    d: "M553.494,140.233h-1.9l11.612-28.886h1.942l11.409,28.886h-1.9l-10.4-27.147h-.081Z",
    transform: "translate(-475.827 -110.685)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24975",
    "data-name": "Group 24975"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_868",
    "data-name": "Ellipse 868",
    cx: 3.419,
    cy: 3.419,
    r: 3.419,
    transform: "translate(39.473 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_869",
    "data-name": "Ellipse 869",
    cx: 2.895,
    cy: 2.895,
    r: 2.895,
    transform: "translate(40.952 9.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_870",
    "data-name": "Ellipse 870",
    cx: 2.449,
    cy: 2.449,
    r: 2.449,
    transform: "translate(40.501 17.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_871",
    "data-name": "Ellipse 871",
    cx: 2.092,
    cy: 2.092,
    r: 2.092,
    transform: "translate(38.622 24.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_872",
    "data-name": "Ellipse 872",
    cx: 1.797,
    cy: 1.797,
    r: 1.797,
    transform: "translate(35.9 29.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_873",
    "data-name": "Ellipse 873",
    cx: 1.543,
    cy: 1.543,
    r: 1.543,
    transform: "translate(32.785 32.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_874",
    "data-name": "Ellipse 874",
    cx: 2.907,
    cy: 2.907,
    r: 2.907,
    transform: "translate(48.579 10.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_875",
    "data-name": "Ellipse 875",
    cx: 2.461,
    cy: 2.461,
    r: 2.461,
    transform: "translate(48.068 18.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_876",
    "data-name": "Ellipse 876",
    cx: 2.081,
    cy: 2.081,
    r: 2.081,
    transform: "translate(46.234 25.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_877",
    "data-name": "Ellipse 877",
    cx: 1.779,
    cy: 1.779,
    r: 1.779,
    transform: "translate(43.495 30.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_878",
    "data-name": "Ellipse 878",
    cx: 1.527,
    cy: 1.527,
    r: 1.527,
    transform: "translate(40.352 33.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_879",
    "data-name": "Ellipse 879",
    cx: 1.311,
    cy: 1.311,
    r: 1.311,
    transform: "translate(37.14 35.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_880",
    "data-name": "Ellipse 880",
    cx: 2.475,
    cy: 2.475,
    r: 2.475,
    transform: "translate(54.09 20.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_881",
    "data-name": "Ellipse 881",
    cx: 2.106,
    cy: 2.106,
    r: 2.106,
    transform: "translate(52.213 27.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_882",
    "data-name": "Ellipse 882",
    cx: 1.82,
    cy: 1.82,
    r: 1.82,
    transform: "translate(49.515 32.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_883",
    "data-name": "Ellipse 883",
    cx: 1.58,
    cy: 1.58,
    r: 1.58,
    transform: "translate(46.36 35.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_884",
    "data-name": "Ellipse 884",
    cx: 1.35,
    cy: 1.35,
    r: 1.35,
    transform: "translate(43.162 38.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_885",
    "data-name": "Ellipse 885",
    cx: 1.146,
    cy: 1.146,
    r: 1.146,
    transform: "translate(40.132 39.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_886",
    "data-name": "Ellipse 886",
    cx: 3.419,
    cy: 3.419,
    r: 3.419,
    transform: "translate(43.377 47.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_887",
    "data-name": "Ellipse 887",
    cx: 2.895,
    cy: 2.895,
    r: 2.895,
    transform: "translate(35.614 44.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_888",
    "data-name": "Ellipse 888",
    cx: 2.449,
    cy: 2.449,
    r: 2.449,
    transform: "translate(29.929 40.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_889",
    "data-name": "Ellipse 889",
    cx: 2.092,
    cy: 2.092,
    r: 2.092,
    transform: "translate(26.078 35.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_890",
    "data-name": "Ellipse 890",
    cx: 1.797,
    cy: 1.797,
    r: 1.797,
    transform: "translate(23.857 31.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_891",
    "data-name": "Ellipse 891",
    cx: 1.543,
    cy: 1.543,
    r: 1.543,
    transform: "translate(22.94 26.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_892",
    "data-name": "Ellipse 892",
    cx: 2.906,
    cy: 2.906,
    r: 2.906,
    transform: "translate(30.869 50.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_893",
    "data-name": "Ellipse 893",
    cx: 2.461,
    cy: 2.461,
    r: 2.461,
    transform: "translate(25.166 46.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_894",
    "data-name": "Ellipse 894",
    cx: 2.081,
    cy: 2.081,
    r: 2.081,
    transform: "translate(21.357 41.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_895",
    "data-name": "Ellipse 895",
    cx: 1.779,
    cy: 1.779,
    r: 1.779,
    transform: "translate(19.146 37.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_896",
    "data-name": "Ellipse 896",
    cx: 1.528,
    cy: 1.528,
    r: 1.528,
    transform: "translate(18.27 32.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_897",
    "data-name": "Ellipse 897",
    cx: 1.312,
    cy: 1.312,
    r: 1.312,
    transform: "translate(18.402 29.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_898",
    "data-name": "Ellipse 898",
    cx: 2.475,
    cy: 2.475,
    r: 2.475,
    transform: "translate(20.202 50.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_899",
    "data-name": "Ellipse 899",
    cx: 2.106,
    cy: 2.106,
    r: 2.106,
    transform: "translate(16.384 45.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_900",
    "data-name": "Ellipse 900",
    cx: 1.819,
    cy: 1.819,
    r: 1.819,
    transform: "translate(14.13 41.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_901",
    "data-name": "Ellipse 901",
    cx: 1.579,
    cy: 1.579,
    r: 1.579,
    transform: "translate(13.206 37.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_902",
    "data-name": "Ellipse 902",
    cx: 1.349,
    cy: 1.349,
    r: 1.349,
    transform: "translate(13.351 33.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_903",
    "data-name": "Ellipse 903",
    cx: 1.146,
    cy: 1.146,
    r: 1.146,
    transform: "translate(14.232 30.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_904",
    "data-name": "Ellipse 904",
    cx: 3.419,
    cy: 3.419,
    r: 3.419,
    transform: "translate(0 27.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_905",
    "data-name": "Ellipse 905",
    cx: 2.895,
    cy: 2.895,
    r: 2.895,
    transform: "translate(7.856 22.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_906",
    "data-name": "Ellipse 906",
    cx: 2.449,
    cy: 2.449,
    r: 2.449,
    transform: "translate(15.328 19.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_907",
    "data-name": "Ellipse 907",
    cx: 2.093,
    cy: 2.093,
    r: 2.093,
    transform: "translate(22.124 19.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_908",
    "data-name": "Ellipse 908",
    cx: 1.797,
    cy: 1.797,
    r: 1.797,
    transform: "translate(27.948 19.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_909",
    "data-name": "Ellipse 909",
    cx: 1.543,
    cy: 1.543,
    r: 1.543,
    transform: "translate(32.737 21.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52475",
    "data-name": "Path 52475",
    d: "M325.741,113.278A2.906,2.906,0,1,1,323.8,116.9a2.906,2.906,0,0,1,1.941-3.622Z",
    transform: "translate(-318.726 -97.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_910",
    "data-name": "Ellipse 910",
    cx: 2.461,
    cy: 2.461,
    r: 2.461,
    transform: "translate(12.495 12.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_911",
    "data-name": "Ellipse 911",
    cx: 2.081,
    cy: 2.081,
    r: 2.081,
    transform: "translate(19.274 12.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_912",
    "data-name": "Ellipse 912",
    cx: 1.778,
    cy: 1.778,
    r: 1.778,
    transform: "translate(25.127 12.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_913",
    "data-name": "Ellipse 913",
    cx: 1.527,
    cy: 1.527,
    r: 1.527,
    transform: "translate(29.896 14.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_914",
    "data-name": "Ellipse 914",
    cx: 1.312,
    cy: 1.312,
    r: 1.312,
    transform: "translate(33.619 16.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_915",
    "data-name": "Ellipse 915",
    cx: 2.475,
    cy: 2.475,
    r: 2.475,
    transform: "translate(11.403 6.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52476",
    "data-name": "Path 52476",
    d: "M347.42,97.289a2.106,2.106,0,1,1-1.948,2.253,2.106,2.106,0,0,1,1.948-2.253Z",
    transform: "translate(-327.264 -91.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_916",
    "data-name": "Ellipse 916",
    cx: 1.82,
    cy: 1.82,
    r: 1.82,
    transform: "translate(24.007 6.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_917",
    "data-name": "Ellipse 917",
    cx: 1.58,
    cy: 1.58,
    r: 1.58,
    transform: "translate(28.801 7.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_918",
    "data-name": "Ellipse 918",
    cx: 1.349,
    cy: 1.349,
    r: 1.349,
    transform: "translate(32.54 9.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52477",
    "data-name": "Path 52477",
    d: "M374.638,108.318a1.146,1.146,0,1,1-1.059,1.226A1.146,1.146,0,0,1,374.638,108.318Z",
    transform: "translate(-338.278 -95.928)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIota);
export default __webpack_public_path__ + "static/media/iota.d4c439a9574a5b0ee710219fa8281597.svg";
export { ForwardRef as ReactComponent };